import type { FaireProductEntity } from "../../entity_types/product";

export const p_hepq9bb8kg: FaireProductEntity = {
  token: "p_hepq9bb8kg",
  type: "product",
  name: "Cream Soda",
  brandToken: "b_2ncsmapy03",
  brandName: "Olipop",
  imageUrl:
    "https://cdn.faire.com/fastly/10e3f885b1cb96063e0c3f7f3e6e72fc4372c7c5a695a1c926c8f5c555f2efa8.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d975b652ab58a68a8c17ff111fee94f367c17ec847ef5d32b20e4c59673edebb.png",
    "https://cdn.faire.com/fastly/8913888873e8ae740f86422c3b176af6e6b96122452c6dba45ff0c0bf022ce9d.png",
    "https://cdn.faire.com/fastly/91a6988f2763fa510701e903b96833a017f7f8f8cf9ecc01eb96d5bedc7ddf2e.png",
    "https://cdn.faire.com/fastly/fc6612993b2c3e3af0884defcaed5966996181391a1b3019e5e79c8298b87926.png",
  ],
  priceDollars: 28.99,
  description:
    "Better than spooning fluffy, sweet marshmallow cream straight out of the jar, our Cream Soda blends irresistibly decadent natural vanilla flavors with premium pure vanilla extract for a sumptuous, smooth soda you’ll savor.\n\nWholesale cost offers landed cost of $2.42 per unit, which provides a 40% gross margin to the retailer at $3.99 MSRP.",
  tags: [],
  msrpDollars: 57.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-30T17:24:08.082Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
